import React from 'react';
import { Skeleton } from '@mui/material';
import { StyledVoiceItemSkeleton } from './index.style';

const VoiceItemSkeleton = () => (
  <StyledVoiceItemSkeleton>
    <Skeleton variant="circular" width={48} height={48} />
    <div className="skeleton-info">
      <div className="skeleton-name">
        <Skeleton variant="rounded" width="100%" height={18} />
      </div>
    </div>
    <div className="skeleton-favourite">
      <Skeleton variant="circular" width={24} height={24} />
    </div>
    <Skeleton variant="circular" width={48} height={48} />
  </StyledVoiceItemSkeleton>
);

export default VoiceItemSkeleton;
